import { type UseQueryOptions, useQuery } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { legacyFeatureFlags } from 'src/utils/legacy-feature-flags';

export const useStripeCustomerPortalUrl = (options?: Pick<UseQueryOptions, 'enabled'>) => {
    return useQuery(
        [queryKeys.stripeClientSecret],
        async () => {
            if (legacyFeatureFlags.billing) {
                let url = 'api/landlord/billing/customer-portal-url';
                const host = window.location.host.includes('localhost') ?
                    'platform-staging.reffie.me' :
                    window.location.host;
                const searchParams = new URLSearchParams();
                searchParams.append('return_url', `https://${host}/landlord/inner/settings?tab=billing`);
                url += `?${searchParams.toString()}`;

                const res = await apiClient(url)
                    .json<{ url: string; }>();
                return res.url;
            } else {
                return;
            }
        },
        {
            ...options,
        }
    );
};
